export default __webpack_public_path__ + "static/media/love-illustration.8b7b400d.svg";